<template>
    <div>
        <div style="position: fixed; width:100%; height:100%; z-index:9999;  opacity: 0.3; 
                top: 0; left: 0;display: block;" ></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;">
                
                <div style="margin-left:-20px;">
                    <button id="regBtn" class="h36 w280  plr15 f18 dlan" @click="reguser" style="cursor:pointer;">新用户注册</button>
                    <button id="regBtn" class="h36 w280  plr15 f18 dlan" @click="binduser" style="cursor:pointer;">老用户绑定</button>
                </div>
            </div>
    </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            loginId:'',
            orgId:'',
            tokenId:'',
            mobileString:'',
            memberIdstr:'',
        }
    },
    mounted(){
        
        this.loginId = this.$route.query.loginId;
        this.orgId = this.$route.query.orgId;
        this.tokenId = this.$route.query.tokenId;
        this.login();
    },
    methods:{
        login(){
            let that = this;
            let data = {'loginId':this.loginId,'orgId':this.orgId,'tokenId':this.tokenId};
            this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/alicrm/alicrmlogin.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code){
                        that.GLOBAL.token = res.data.token
                        setCookie('2officesessionid',res.data.token,60*60*10)
                        localStorage.setItem("orgId", res.data.orgId);
                        localStorage.setItem("loginId",res.data.loginId);
                        localStorage.setItem("mobileString", res.data.mobileString);
                        localStorage.setItem("memberIdstr", res.data.memberIdstr);
                        location.href = '/main';
                    }
                    else if('0010001' == res.data.code){
                        that.mobileString = res.data.mobileString;
                        that.memberIdstr = res.data.memberIdstr;
                    }
                    else{
                        alert("认证失败!重新返首页登录");
                        location.href = '/';
                    }
                })
        },
        reguser(){
            this.$router.push({
                path: 'AliCrmReg',
                params: {
                    loginId: this.loginId,
                    orgId: this.orgId,
                    mobileString:this.mobileString,
                    memberIdstr:this.memberIdstr
                }
            })
        },
        binduser(){
            this.$router.push({
                name: 'AliCrmBind', 
                params: {
                    loginId: this.loginId,
                    orgId: this.orgId,
                    mobileString:this.mobileString,
                    memberIdstr:this.memberIdstr
                }
            })
        }
    }
    
}
</script>
<style>
#wrapper {display:table;width:100%;height:100%;background:#000;margin:0 auto;color:red;}
#cell{display:table-cell; vertical-align:middle;}
</style>



// WEBPACK FOOTER //
// src/components/alicrm/alicrmlogin.vue